'use client';

import { cn } from '@/lib/utils';
import { ArrowDownToLine } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { forwardRef, InputHTMLAttributes } from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';
import ErrorText from './ErrorText';

interface FileInputProps extends InputHTMLAttributes<HTMLInputElement> {
    required?: boolean;
    className?: string;
    register?: UseFormRegister<any>;
    error?: FieldError;
}

const FileInput = forwardRef<HTMLInputElement, FileInputProps>((props, ref) => {
    const { className, required, register, error, ...inputProps } = props;

    const t = useTranslations('Form');

    return (
        <div className={cn('flex flex-col relative', className)}>
            <input
                {...register}
                {...inputProps}
                ref={ref}
                type="file"
                className="hidden"
                required={required}
            />
            <label
                className="rounded-30 border-primary font-medium text-h5 px-6 py-[10px] focus:outline-none flex justify-center items-center transition-all max-sm:py-[6px] max-sm:px-2 outline-none border bg-transparent border-solid border-dark-grey text-dark-grey hover:bg-brand hover:text-white hover:border-brand cursor-pointer"
                htmlFor={inputProps.id}
            >
                {t('uploadFiles')}
                <ArrowDownToLine className="ml-4" width={24} height={24} />
            </label>
            {error && <ErrorText error={error} />}
        </div>
    );
});

FileInput.displayName = 'FileInput';

export default FileInput;
